
import { environment } from "../../environments/environment";

export const apiEndpoints = {
    individualUSers: {
        newUser: environment.apiUrl + "newUserTester",
        getUser: environment.apiUrl + "getUserTester", // Not available
        updateUser: environment.apiUrl + "updateUserTesterStatus",
        listUsers: environment.apiUrl + "listUserTesters",
        deleteUser: environment.apiUrl + "deleteUserTester"
    },
    corporateUSers:{
        newDomain: environment.apiUrl + "newDomain",
        updateDomain: environment.apiUrl + "updateDomain",
        getDomain: environment.apiUrl + "getDomain",
        listDomains: environment.apiUrl + "listDomains",
        deleteDomain: environment.apiUrl + "deleteDomain",
        // Individual users within the domain (not needed here)
        newUser: environment.apiUrl + "newUser",
        updateUser: environment.apiUrl + "updateUser",
        deleteUser: environment.apiUrl + "deleteUser",
    },
    analysisCount:{
        userAnalysisCount: environment.apiUrl + "getUserAnalysisCount",
        domainAnalysisCount: environment.apiUrl + "getDomainAnalysisCount",
        globalAnalysisCount: environment.apiUrl + "getGlobalAnalysisCount",
        domainActivity: environment.apiUrl + "getDomainActivity",
    }
}

export const configurationValues = {
    regionList: ['eu', 'us', 'uk'],
    languageList: ['es', 'en'],
    dbCollaboratorOptions: [false, true],
    emailAndPasswordAuthOptions: [false, true],
    passwordRotationList: [0, 30, 45, 90, 180]
}